// https://vuex.vuejs.org/en/state.html
/* eslint no-param-reassign:0 */
export default {
  appVersion: state => state.appVersion,
  restApi: state => state.restApi,
  user: state => state.user,
  client: state => state.client,
  currentLang: state => state.lang,
};
